<template>
  <div class="d-flex">
      <div class="col-md-3">
       <Panelcommission :selectedComissao="dataDetails" ></Panelcommission>
      </div>
      <div class="col-md-9">
        <b-tabs v-model="tabIndex">
        <b-tab :title="'Comissões'">
            <template slot="title">
                <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Comissões</span></div>
            </template>
            <Commissionform :selectedComissao="dataDetails" ></Commissionform>
        </b-tab>
         <b-tab :title="'Informações de Venda'">
        <template slot="title">
            <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Informações de Venda</span></div>
        </template>
              <Salesinformation :selectedComissao="dataDetails"></Salesinformation>
        </b-tab>
        </b-tabs>
      </div>
  </div>
</template>

<script>
import Commissiondetails from './commissiondetails'
export default Commissiondetails
</script>

<style scoped>

#body-details{
    height: 60vh;
}

.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
}

.input-details{
    width: 100%;
    height: 35px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}

.label-details{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;

}
.result-details{
    font-size: 16px;
    font-weight: bold;

}

.head-right {
  height: 59px;
  display: flex;
  width: 100%;
  background: #ECEFF1 0% 0% no-repeat padding-box;
  border: 1px solid #CFD8DC;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
}

#details-board{
    height: 80vh;
    width: 100%;
    background-color:white;
}

.text-tabs{
    color: #008148;
}
#card-details{
    width: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
}

#footer-card-details{
    display: flex;
    font-size: 35px;
}

#nameTower{
    color: rgb(90, 90, 90);
    font-size: 30px;
    font-weight: bold;
}

#card-img{
    height: 250px;
}

#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}
hr{
    width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/components/commissiondetails/commissiondetails.vue